import { Injectable } from '@angular/core';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { JobsService } from './jobs-service';

@Injectable({
  providedIn: 'root',
})
export class EmployeePositionNamesResolver {
  constructor(
    private jobService: JobsService,
    private applicationModel: ApplicationModel
  ) {}

  public load(): Promise<string[]> {
    if (this.applicationModel.employeePositionNames.length === 0) {
      return this.jobService
        .getEmployeePositionNames()
        .then(
          (data: typeof this.applicationModel.employeePositionNames) =>
            (this.applicationModel.employeePositionNames = data)
        );
    }

    return Promise.resolve(this.applicationModel.employeePositionNames);
  }
}
